import { BrokerAgreementSummary } from '../../../../../../../queries/brokerAgreementQueries';

/** The agreement broker's full name, then business name. */
export const BrokerName = ({ broker }: { broker: NonNullable<BrokerAgreementSummary['broker']> }) => {
    return (
        <>
            {broker.fullName && (
                <div>
                    <b>{broker.fullName}</b>
                </div>
            )}
            {broker.businessName && (
                <div>
                    <b>{broker.businessName}</b>
                </div>
            )}
        </>
    );
};
